import React, { useState } from 'react';
import { StyleSheet, View, Image } from 'react-native';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style.js';
import { MainButton } from '../buttons/MainButton.js';

const searchGif = require('../../assets/icons/friends/search.gif');

const dimensions = 500;
const imageHeight = Math.round(dimensions * (9 / 18));
const imageWidth = dimensions;

const styles = StyleSheet.create({
  grayLayer: {
    display: 'flex',
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
    backgroundColor: theme.BLACK_COLOR_TRANSPARENT,
    width: '100vw',
    maxWidth: 920,
    height: '110%',
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    paddingTop: 10,
    padding: 20,
    marginTop: -10,
    marginHorizontal: -20,
  },
  container: {
    padding: theme.CONTAINER_MARGIN,
    backgroundColor: theme.WHITE_COLOR,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 30,
    zIndex: 1000,
  },
  innerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headline: {
    fontSize: theme.FONT_SIZE_HEADLINE,
    color: theme.WHITE_COLOR,
    fontWeight: theme.FONT_WEIGHT_BOLD,
    marginBottom: 5,
    textAlign: 'center',
  },
  text: {
    fontSize: theme.FONT_SIZE_TITLE,
    color: theme.GREEN_DARKER_COLOR,
    paddingBottom: 20,
    textAlign: 'center',
  },
  searchGif: {
    width: imageWidth,
    height: imageHeight,
    maxWidth: '100%',
  },
});

export const AddFriendPopUp = () => {
  const [showPopUp, setShowPopUp] = useState(true);
  if (showPopUp) {
    return (
      <View style={styles.grayLayer}>
        <View style={styles.container}>
          <View style={styles.innerContainer}>
            <CustomText style={styles.text}>Use the search bar to add some friends!</CustomText>
            <Image style={styles.searchGif} source={searchGif} />
            <MainButton
              title="Got it!"
              btnBgColor={theme.GREEN_DARKER_COLOR}
              textColor={theme.WHITE_COLOR}
              btnTextSize={15}
              btnWidth={200}
              btnPadding="5%"
              btnPress={() => setShowPopUp(false)}
              style={styles.loginButton}
            />
          </View>
        </View>
      </View>
    );
  }
  return null;
};
